import { metalPanel, gameColors } from '@/shared/ui/game-theme';
import { useLocale } from '@/i18n';
import type { CSSProperties } from 'react';
import type { HeroState, LootDrop } from '@/game/types';

interface InventoryStripProps {
  /** Kept for call sites; gold is shown on HUD and in the inventory tab. */
  hero: HeroState;
  /** Most recent victory loot (gold + optional item); persists after popup fades */
  lastLoot?: LootDrop | null;
}

function formatLastLootLine(loot: LootDrop, goldLabel: string, victoryLabel: string): string {
  const parts: string[] = [];
  if (loot.goldAmount > 0) {
    parts.push(`+${loot.goldAmount.toLocaleString()} ${goldLabel}`);
  }
  if (loot.bonusItem?.itemName) {
    parts.push(loot.bonusItem.itemName);
  } else if (loot.itemName && !loot.bonusItem) {
    parts.push(loot.itemName);
  }
  return parts.join(' \u00B7 ') || victoryLabel;
}

const stripStyle: CSSProperties = {
  marginTop: 4,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '3px 8px',
  borderRadius: 8,
  background: 'rgba(10, 16, 24, 0.72)',
  border: '1px solid rgba(255, 255, 255, 0.14)',
  fontSize: 12,
  minHeight: 23,
  minWidth: 0,
  ...metalPanel,
};

const lastLootStyle: CSSProperties = {
  fontSize: 12,
  color: gameColors.muted,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  minWidth: 0,
  maxWidth: '100%',
};

export function InventoryStrip({ lastLoot }: InventoryStripProps) {
  const { locale } = useLocale();
  if (!lastLoot) return null;
  const line = formatLastLootLine(lastLoot, locale === 'ru' ? 'монет' : 'gold', locale === 'ru' ? 'Победа' : 'Victory');
  return (
    <div style={stripStyle}>
      <div style={lastLootStyle} title={line}>
        {line}
      </div>
    </div>
  );
}
